<template>
  <div class="company-certification-form">
    <div class='upload-certificates-form'>
      <div class="add-certificate-form">
        <div class="certificates-inputs" v-for="(value, index) in manualCertificates" :key="index">
          <div class="text-field-section">
            <text-field
              type="text"
              v-model="manualCertificates[index].name"
              class="login"
              :label="$t('certificate.add.manual.label')"
              :placeholder="$t('certificate.add.manual.placeholder')"
            />
            <CertificateScan
              v-if="manualCertificates[index].name"
              :certificateCode="index"
              :is-manual="true"
              @changed="formChanged"
            />
          </div>
          <div class="add-new-certificate-section">
            <v-btn color='#B331CF' v-if='index === manualCertificates.length-1' :disabled="!manualCertificates[index].name" class="add-btn" @click="addManualCertificate">
              <span class="plus">+</span>{{ $t('certificate.add.manual.add.button') }}
            </v-btn>
          </div>
        </div>
      </div>
      <div v-for="(certificate) in spFreelancerCertificates" :key="certificate.code">
        <custom-checkbox
          :title="$t(`${certificate.code}`)"
          :value="checkBoxValues[certificate.code]"
          class="feature-checkbox"
          color="cold-marine"
          @input="onSelect(certificate)"
        />
        <CertificateScan
          v-if="checkBoxValues[certificate.code]"
          :certificateCode="certificate.code"
          :is-manual="false"
          @changed="formChanged"
        />
      </div>
    </div>
    <div class="add-social-network-link-form">
      <v-form ref="form">
        <v-text-field
          :rules="[rules.linkedin]"
          v-model="spFreelancerRegistrationCompanySocialNetworkLinkInfo.linkedinLink"
          dense
          outlined
          required
          :label="$t('registration.sp.freelancer.company.certification.linkedin.label')"
          :placeholder="$t('registration.sp.freelancer.company.certification.linkedin.placeholder')"
        />
        <v-text-field
          :rules="[rules.anyWebsite]"
          v-model="spFreelancerRegistrationCompanySocialNetworkLinkInfo.otherLink"
          dense
          outlined
          required
          :label="$t('registration.sp.freelancer.company.certification.other.social.network.label')"
          :placeholder="$t('registration.sp.freelancer.company.certification.other.social.network.placeholder')"
        />
      </v-form>
    </div>
    <div class="content">
      <div class="add-white-ip-title">
        {{ $t('registration.sp.freelancer.company.certification.white.ip.title') }}
      </div>
      <div class="add-ip-section">
        <v-text-field
          :rules='[rules.hostWithRange]'
          v-model="spFreelancerRegistrationCompanyIpAddressInfo.ipAddress"
          :label="$t('registration.sp.freelancer.company.certification.white.ip.label')"
          :placeholder="$t('registration.sp.freelancer.company.certification.white.ip.placeholder')"
          dense
          outlined
          required
        />
      </div>
    </div>
    <div class="content">
      <div class="add-recommendations-title">
        {{ $t('registration.sp.freelancer.company.certification.recommendation.title') }}
      </div>
      <div class="add-recommendations-sub-title">
        {{ $t('registration.sp.freelancer.company.certification.recommendation.sub.title') }}
      </div>
      <div class="add-recommendations-form">
        <div class="emails-inputs" v-for="(value, index) in spFreelancerRegistrationCompanyRecommendationInfo.recommendations" :key="index">
          <div class="text-field-section">
            <v-text-field
              :rules="[rules.email]"
              v-model="spFreelancerRegistrationCompanyRecommendationInfo.recommendations[index]"
              :ref='index'
              dense
              outlined
              required
              :label="$t('registration.sp.freelancer.company.certification.recommendation.label')"
              :placeholder="$t('registration.sp.freelancer.company.certification.recommendation.placeholder')"
            />
          </div>
          <span
            v-if='isDeletable(index)'
            class="delete-icon material-icons"
            @click="deleteRecommendation(index)"
          >
            highlight_off
          </span>
        </div>
        <div class="add-new-email-section">
          <div class="add-new-email-header">
            <label  class="add-new-email-add-button" @click="addRecommendation">
              <v-icon color="#B331CF">add</v-icon>
              {{ $t('registration.sp.freelancer.company.certification.recommendation.add') }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { rules } from '@/utils/validationUtils';
import CertificateScan from '@/components/spFreelancerRegistration/CertificateScan.vue';
import {
  CHANGE_SP_FREELANCER_COMPANY_CERTIFICATION,
  CHANGE_SP_FREELANCER_FORTH_STEP_REGISTRATION_VALID,
} from '@/store/spFreelancerRegistration/actionTypes';
import CustomCheckbox from '@/components/common/CustomCheckbox.vue';
import TextField from '@/components/common/TextField.vue';

export default {
  name: 'CompanyCertificationForm',
  components: {
    CustomCheckbox,
    TextField,
    CertificateScan,
  },
  mounted() {
    this.fileReader = new FileReader();
    this.fileReader.onload = this.onFileReaded;
    if (!this.spFreelancerRegistrationCompanyRecommendationInfo.recommendations.length) {
      this.spFreelancerRegistrationCompanyRecommendationInfo.recommendations.push('');
      this.spFreelancerRegistrationCompanyRecommendationInfo.recommendations.push('');
    }
  },
  data() {
    return {
      manualCertificates: [{name: '', file: ''}],
      certificatesListChosen: [],
      selectedFile: {},
      isSelecting: false,
    };
  },
  computed: {
    ...mapGetters([
      'allowNextForthStepSPFreelancer',
      'spFreelancerCertificates',
      'spFreelancerRegistrationForthStepValid',
      'spFreelancerRegistrationCompanyCertificationInfo',
      'spFreelancerRegistrationCompanyIpAddressInfo',
      'spFreelancerRegistrationCompanyRecommendationInfo',
      'spFreelancerRegistrationCompanySocialNetworkLinkInfo',
    ]),
    rules() {
      return rules;
    },
    validForm() {
      return this.rules.hostWithRange(this.spFreelancerRegistrationCompanyIpAddressInfo.ipAddress) &&
        this.rules.linkedin(this.spFreelancerRegistrationCompanySocialNetworkLinkInfo.linkedinLink) &&
        this.rules.anyWebsite(this.spFreelancerRegistrationCompanySocialNetworkLinkInfo.otherLink) &&
        this.spFreelancerRegistrationCompanyRecommendationInfo.recommendations.map(recommendation => this.rules.email(recommendation)).every(value => value);
    },
    checkBoxValues() {
      const certificatesValueObject = {};
      this.spFreelancerCertificates.forEach(certificate => {
        certificatesValueObject[certificate.code] = this.certificatesListChosen.includes(certificate.code);
      });
      return certificatesValueObject;
    },
    allCertificatesInfo() {
      const defaultCertificatesWithScanData = [];
      this.certificatesListChosen.forEach(certificate => {
        if (Object.keys(this.selectedFile).includes(certificate)) {
          defaultCertificatesWithScanData.push({
            code: certificate,
            file: this.selectedFile[certificate],
          });
        } else {
          defaultCertificatesWithScanData.push({
            code: certificate,
            file: null,
          });
        }
      });
      return {
        manualCertifications: this.manualCertificates,
        defaultCertifications: defaultCertificatesWithScanData,
      };
    },
  },
  watch: {
    certificatesListChosen() {
      this.formChanged();
    },
    'spFreelancerRegistrationCompanyRecommendationInfo.recommendations': {
      async handler() {
        await this.$store.dispatch(CHANGE_SP_FREELANCER_FORTH_STEP_REGISTRATION_VALID, this.validForm);
      },
      deep: true,
    },
    'spFreelancerRegistrationCompanySocialNetworkLinkInfo.linkedinLink': {
      async handler() {
        await this.$store.dispatch(CHANGE_SP_FREELANCER_FORTH_STEP_REGISTRATION_VALID, this.validForm);
      },
      deep: true,
    },
    'spFreelancerRegistrationCompanySocialNetworkLinkInfo.otherLink': {
      async handler() {
        await this.$store.dispatch(CHANGE_SP_FREELANCER_FORTH_STEP_REGISTRATION_VALID, this.validForm);
      },
      deep: true,
    },
    'spFreelancerRegistrationCompanyIpAddressInfo.ipAddress': {
      async handler() {
        await this.$store.dispatch(CHANGE_SP_FREELANCER_FORTH_STEP_REGISTRATION_VALID, this.validForm);
      },
      deep: true,
    },
  },
  methods: {
    isDeletable(index) {
      return !(index === 1 || index === 0);
    },
    addRecommendation() {
      this.spFreelancerRegistrationCompanyRecommendationInfo.recommendations.push('');
    },
    deleteRecommendation(index) {
      this.spFreelancerRegistrationCompanyRecommendationInfo.recommendations.splice(index, 1);
    },
    addManualCertificate() {
      this.manualCertificates.push({ name: '', file: '' });
    },
    async formChanged(value) {
      if (value?.isManual) {
        this.manualCertificates[value.code].file = value.file;
      } else {
        this.selectedFile[value?.code] = value?.file;
      }
      await this.$store.dispatch(CHANGE_SP_FREELANCER_COMPANY_CERTIFICATION, this.allCertificatesInfo);
    },
    onSelect(certificate) {
      if (!this.certificatesListChosen.includes(certificate.code)) {
        this.certificatesListChosen.push(certificate.code);
      } else {
        const index = this.spFreelancerCertificates.findIndex(element => element === certificate.code);
        this.certificatesListChosen.splice(index, 1);
      }
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none !important;
}

.add-social-network-link-form {
  width: rem(444);
  margin-bottom: rem(32);
}

.linkedin-link {
  margin-top: rem(18);
}

.other-link {
  margin-top: rem(8);
}

.upload-certificates-form {
  height: rem(311);
  overflow-y: scroll;
  overflow-x: hidden;
  margin-bottom: rem(40);

  .file-name {
    height: rem(16);
    color: $auth-text-muted;
    font-family: $font-family-medium;
    font-size: rem(12);
    font-weight: 500;
    letter-spacing: rem(1.07);
    line-height: rem(16);
    text-align: center;
  }
}

.checkbox-container {
  margin-bottom: rem(10) !important;
}

.btn-text-upload-scan {
  height: rem(16);
  width: rem(132);
  color: #5c6670;
  font-family: $font-family-medium;
  font-size: rem(12);
  font-weight: 500;
  letter-spacing: rem(1.07);
  line-height: rem(16);
  text-align: center;
}

.add-certificate-form {
  margin-bottom: rem(32);

  .certificates-inputs {
    display: flex;

    .text-field-section {
      flex: 0 0 75%;
    }

    .add-new-certificate-section {
      color: #9BB0BE;
      font-family: $font-family-regular;
      font-size: rem(12);
      font-weight: 500;
      letter-spacing: rem(1.07);
      line-height: rem(16);
      text-align: center;
      flex: 1;
      height: rem(32);
      margin-top: rem(17);

      .plus {
        font-size: rem(16);
        margin-top: rem(-3);
      }

      .add-btn {
        width: rem(86);
        color: #FFFFFF;
      }
    }
  }
}

.add-white-ip-title {
  width: rem(444);
  color: $auth-text-primary;
  font-family: $font-family-regular;
  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(18);
}

.v-text-field__details {
  display: none;
}

#app .v-text-field .v-text-field__details {
  padding-left: 0;
  display: none;
}

.add-ip-section {
  margin-bottom: rem(32);
  width: rem(444);
}

.add-recommendations-title {
  height: rem(36);
  color: $auth-text-primary;
  font-family: $font-family-regular;
  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(18);
  margin-bottom: rem(8);
}

.add-recommendations-sub-title {
  height: rem(36);
  color: $auth-text-muted;
  font-family: $font-family-regular;
  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(18);
  margin-bottom: rem(15);
}

.add-recommendations-form {
  margin-bottom: rem(32);

  .emails-inputs {
    display: flex;
    align-items: center;

    .text-field-section {
      flex: 0 0 rem(444);
    }

    .delete-row-section {
      flex: 1;
    }

    .delete-icon {
      color: rgb(224, 37, 94);
      cursor: pointer;
      margin-left: rem(5);
      font-size: rem(18);
      margin-bottom: rem(-15);
      font-weight: 600;
    }

    .dummy-icon {
      width: rem(16);
      height: rem(16);
    }
  }

  .add-new-email-section {
    padding: 0;

    .add-new-email-header {
      display: flex;
      justify-content: space-between;

      .add-new-email-add-button {
        padding-top: rem(15);
        height: rem(16);
        color: #5c6670;
        font-family: $font-family-regular;
        font-size: rem(13);
        font-weight: 500;
        letter-spacing: rem(1.07);
        line-height: rem(16);
        text-align: center;

        .plus {
          font-size: rem(17);
          margin-top: rem(-3);
        }
      }
    }
  }
}

.invite-users-popup {
  .popup-wrapper {
    max-width: rem(372);
    padding: rem(32) rem(40);
    overflow: scroll;

    .content {
      .invite-title {
        text-transform: uppercase;
        color: $auth-text-primary;
        font-size: rem(14);
        font-weight: 600;
        letter-spacing: rem(1.12);
        line-height: rem(16);
        margin-bottom: rem(16);
      }
    }

    .buttons {
      text-align: right;
      padding-top: rem(30);

      .cancel-button {
        box-sizing: border-box;
        height: rem(32);
        width: rem(86);
        border: rem(1) solid #8f24d0;
        color: #8f24d0;
        border-radius: $radius-sm;
        background-color: #ffffff;
        box-shadow: 0 rem(1) rem(1) 0 rgb(0 0 0 / 14%), 0 rem(2) rem(1) rem(-1) rgb(0 0 0 / 12%), 0 rem(1) rem(3) 0 rgb(0 0 0 / 20%) !important;
      }

      .save-button {
        height: rem(32);
        width: rem(113);
        border-radius: $radius-sm;
        background-color: #8f24d0 !important;
        box-shadow: 0 rem(1) rem(1) 0 #dbdbdb, 0 rem(2) rem(1) rem(-1) #e0e0e0, 0 rem(1) rem(3) 0 #cccccc !important;
        color: #ffffff;
        font-size: rem(12);
        font-weight: 500;
        letter-spacing: rem(1.07);
        line-height: rem(16);
        text-align: center;
        margin-left: rem(8);
      }
    }
  }
}
</style>
